module.exports = __webpack_public_path__ + "static/media/rows-of-casks.1d44ab4c.png";